// Marketing pixels — Meta (Facebook), Google (GA4 / Ads), TikTok.
// Each pixel ONLY initializes when its ID is provided via env vars, so
// nothing fires with placeholder values. Set these in /app/frontend/.env:
//   REACT_APP_FB_PIXEL_ID=xxxxxxxxxxxxxxx
//   REACT_APP_GA_ID=G-XXXXXXXXXX        (GA4)  or  AW-XXXXXXXXX (Google Ads)
//   REACT_APP_TIKTOK_PIXEL_ID=XXXXXXXXXXXXXXXXXXXX

const FB_ID = process.env.REACT_APP_FB_PIXEL_ID;
const GA_ID = process.env.REACT_APP_GA_ID;
const TT_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

let initialized = false;

function initMeta(id) {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

function initGoogle(id) {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

function initTikTok(id) {
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = r;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = !0;
      s.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(s, a);
    };
    ttq.load(id);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function initPixels() {
  if (initialized) return;
  initialized = true;
  if (FB_ID) initMeta(FB_ID);
  if (GA_ID) initGoogle(GA_ID);
  if (TT_ID) initTikTok(TT_ID);
}

// Fire a lead/conversion event across all configured platforms.
export function trackLead(data = {}) {
  if (FB_ID && window.fbq) window.fbq("track", "Lead", data);
  if (GA_ID && window.gtag) window.gtag("event", "generate_lead", data);
  if (TT_ID && window.ttq) window.ttq.track("SubmitForm", data);
}
